// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import _ from 'underscore';

import { Auth } from 'app/scripts/db/Auth';
import { Alerts } from 'app/scripts/views/lib/Alerts';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const showFileSizeError = function (board: any) {
  const boardHasLargeAttachments =
    board?.isFeatureEnabled('largeAttachments') || false;

  const message = boardHasLargeAttachments
    ? 'file size exceeds 250mb'
    : 'file size exceeds 10mb';

  return Alerts.show(message, 'error', 'upload', 5000);
};

/**
 * Use `useFileSizeAlert` instead.
 * @deprecated
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function warnIfFileTooLarge(board: any, files: any) {
  if (!_.isArray(files)) {
    files = [files];
  }

  for (const file of Array.from(files)) {
    if (!Auth.me().canUploadAttachment(file, board)) {
      showFileSizeError(board);
      return true;
    }
  }

  return false;
}
